<script>
	import Card from "./Card.svelte"
	import Modal from "./Modal.svelte"
	import InfoModal from "./InfoModal.svelte"
	let isModal = false,
		textModal

	function handleModal (n) {
		let html = document.getElementsByTagName("html")[0]
		isModal = !isModal
		if(isModal){
			html.style.overflow = "hidden"
		} else {
			html.style.overflow = "auto"
		}
	}
</script>

<main class="Main">
	<h2 class="Main--title">¿Cómo te puedo ayudar?</h2>
	<div class="Main--content__card">
		<Card
			title="Landing Page"
			nameImg="services1.svg"
			alt="Web View"
			description="Lo fundamental para cualquier persona, empresa o servicio es tener una página de lanzamiento o mejor conocida como landing page, donde de a conocer sus servicios, productos, conocimiento... Si quieres lanzarte al mundo web, lo primero es tener tu propia landing page.">
		</Card>
		<!-- <Card
			title="Ecommerce"
			nameImg="services2.svg"
			alt="Programmer"
			description="Podemos crear un ecomerce, para venta de tus productos o contenido digital que tengas, creemos tu propia tienda online.">
		</Card> -->
		<Card
			title="Diseñando"
			nameImg="services3.svg" alt="Designer"
			description="De las cosas más importantes que necesita tu site, es la presentación, un buen diseño y una estética impecable que cuide de cada detalle.">
		</Card>
	</div>
</main>

<style>
	.Main{
	padding: 2rem;	
	text-align: center;
	}
	.Main--title{
		margin-bottom: 3rem;
	}
	.Main--content__card{
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		grid-gap: 2rem;
	}
	.Card--link{
		color: var(--principal-ad);
		font-weight: 900;
		background-color: transparent;
		border: none;
		outline: none;
		cursor: pointer;
		font-size: 1.05rem;
	}
	@media screen and (min-width: 768px) {
		.Main{
			padding: 5.5rem;
		}
	}
</style>
<!-- Prueba de boton -->

<!-- <button
				class="Card--link"
				on:click={handleModal}
				on:click={() => textModal = "Funciona con la card 3"}
			>
				Más Info
			</button> -->




<!-- {#if isModal}
	<Modal>
		<InfoModal infoModal={textModal} on:click={handleModal} />
	</Modal>
{/if} -->